import { createAction } from 'redux-actions';

export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';

export const setLoadingOn = createAction<void>(SET_LOADING_ON);
export const setLoadingOff = createAction<void>(SET_LOADING_OFF);
